import { connect } from 'react-redux';
import { pushModal } from '../../../Modals/redux/basicActions';
import { ModalType } from '../../../Modals/redux/types';
import { changeGalleryId } from '../../../WixPortfolio/redux/actions';
import { getCurrentUserHasWixPortfolio } from '../../../publicSession/selectors';
var mapStateToProps = function (state) { return ({
    hasWixPortfolio: Boolean(getCurrentUserHasWixPortfolio(state)),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    openWixPortfolioModal: function (gallection) {
        dispatch(pushModal(ModalType.WIX_PORTFOLIO_CREATE, {
            wrapInModal: false,
        }));
        dispatch(changeGalleryId(gallection.folderId));
    },
}); };
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=FeaturedGallectionControlButtons.container.js.map